import * as React from "react";

export function HashLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a className="mono" href={href}>
      {children}
    </a>
  );
}

export function shortHash(h?: string, n = 10) {
  if (!h) return "";
  if (h.length <= n * 2) return h;
  return h.slice(0, n) + "…" + h.slice(-n);
}

export function DataTable({
  headers,
  rows,
}: {
  headers: React.ReactNode[];
  rows: React.ReactNode[][];
}) {
  return (
    <table className="data">
      <thead>
        <tr>
          {headers.map((h, i) => (
            <th key={i}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {row.map((cell, j) => (
              <td key={j}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function go(route: string, params: Record<string, string> = {}) {
  const q = new URLSearchParams({ route, ...params });
  window.location.href = "index.html?" + q.toString();
}
